import http from "./axios";

export default {
  async getTags() {
    try {
      return await http.get(`/api/tags`);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};
